import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import classNames from 'classnames/bind';
import { useModalOpen } from '@src/hooks/useModalOpen';

const cx = classNames.bind(styles);

const Dialog = ({
    children,
    maskClosable = true,
    onCancel = () => {},
    onOk = () => {},
    onClose = () => {},
    okText = 'OK',
    cancelText = 'Cancel',
}) => {
    useModalOpen();

    const close = () => {
        onClose();
    };

    const handleOk = () => {
        onOk();
        close();
    };

    const handleCancel = () => {
        onCancel();
        close();
    };

    const handleClose = () => {
        close();
    };

    return (
        <div className={styles.wrap}>
            <div
                className={styles.mask}
                onClick={() => {
                    if (maskClosable) {
                        handleClose();
                    }
                }}>
                <div
                    className={styles.modal}
                    onClick={e => {
                        e.stopPropagation();
                    }}>
                    <div className={styles.content}>{children}</div>
                    <div className={styles.footer}>
                        <div className={cx('footerBtn', 'cancelBtn')} onClick={handleCancel}>
                            {cancelText}
                        </div>
                        <div className={cx('footerBtn', 'okBtn')} onClick={handleOk}>
                            {okText}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Dialog.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    maskClosable: PropTypes.bool,
    onCancel: PropTypes.func,
    onOk: PropTypes.func,
    onClose: PropTypes.func,
    okText: PropTypes.string,
    cancelText: PropTypes.string,
};

export default errorBoundary(Dialog);
